import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetUnifiedProfileQuery } from '@/services/endpoints/unifiedProfiles';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { UnifiedProfileAudiencesSection, UnifiedProfileDatasourcesSection, UnifiedProfileDetailsSection, UnifiedProfileTraitsSection } from './sections';

export const UnifiedProfileDataTab: FC = () => {
  const { id: unifiedProfileId } = useParams<{ id: string }>();
  const workspace = useWorkspace();

  const { data: unifiedProfile } = useGetUnifiedProfileQuery({
    unifiedProfileId,
    workspaceId: workspace.id,
  });

  return (
    <div className='grid gap-y-6'>
      <UnifiedProfileDetailsSection />
      <div className='flex flex-col gap-12'>
        <UnifiedProfileTraitsSection />
        <UnifiedProfileAudiencesSection audienceIds={unifiedProfile?.audienceIds} />
        <UnifiedProfileDatasourcesSection datasourceIds={unifiedProfile?.datasourceIds} />
      </div>
    </div>
  );
};
